export const csaStatusOption = [
  { value: 'NEW', label: 'NEW' },
  { value: 'PROCESSED', label: 'PROCESSED' },
  { value: 'COMPLETE', label: 'COMPLETE' },
  { value: 'CSA_REVOKED', label: 'CSA REVOKED' },
  { value: 'DATA CHANGE', label: 'DATA CHANGE' },
  { value: 'REVOKE', label: 'REVOKE' },
  { value: 'REVOKE AND DATA CHAN', label: 'REVOKE AND DATA CHAN' },
  { value: '%25', label: 'ALL' },
];
